import {useSlotProps as $bJbxN$useSlotProps, useStyleProps as $bJbxN$useStyleProps, viewStyleProps as $bJbxN$viewStyleProps, useDOMRef as $bJbxN$useDOMRef, ClearSlots as $bJbxN$ClearSlots} from "@react-spectrum/utils";
import {filterDOMProps as $bJbxN$filterDOMProps} from "@react-aria/utils";
import $bJbxN$react, {forwardRef as $bJbxN$forwardRef} from "react";

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 


function $b9606c0c41d55371$var$View(props, ref) {
    props = (0, $bJbxN$useSlotProps)(props);
    let { elementType: ElementType = "div", children: children, ...otherProps } = props;
    let { styleProps: styleProps } = (0, $bJbxN$useStyleProps)(props, (0, $bJbxN$viewStyleProps));
    let domRef = (0, $bJbxN$useDOMRef)(ref);
    return /*#__PURE__*/ (0, $bJbxN$react).createElement(ElementType, {
        ...(0, $bJbxN$filterDOMProps)(otherProps),
        ...styleProps,
        ref: domRef
    }, /*#__PURE__*/ (0, $bJbxN$react).createElement((0, $bJbxN$ClearSlots), null, children));
}
/**
 * View is a general purpose container with no specific semantics that can be used for custom styling purposes.
 * It supports Spectrum style props to ensure consistency with other Spectrum components.
 */ const $b9606c0c41d55371$export$27a5bd065ad55220 = /*#__PURE__*/ (0, $bJbxN$forwardRef)($b9606c0c41d55371$var$View);


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 


function $0a7c18a2ef74b280$var$Content(props, ref) {
    props = (0, $bJbxN$useSlotProps)(props, "content");
    let { children: children, ...otherProps } = props;
    let { styleProps: styleProps } = (0, $bJbxN$useStyleProps)(otherProps);
    let domRef = (0, $bJbxN$useDOMRef)(ref);
    return /*#__PURE__*/ (0, $bJbxN$react).createElement("section", {
        ...(0, $bJbxN$filterDOMProps)(otherProps),
        ...styleProps,
        ref: domRef
    }, /*#__PURE__*/ (0, $bJbxN$react).createElement((0, $bJbxN$ClearSlots), null, children));
}
/**
 * Content represents the primary content within a Spectrum container.
 */ const $0a7c18a2ef74b280$export$7c6e2c02157bb7d2 = /*#__PURE__*/ (0, $bJbxN$forwardRef)($0a7c18a2ef74b280$var$Content);


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 


function $8d68cc89c1f9278e$var$Footer(props, ref) {
    props = (0, $bJbxN$useSlotProps)(props, "footer");
    let { children: children, ...otherProps } = props;
    let { styleProps: styleProps } = (0, $bJbxN$useStyleProps)(otherProps);
    let domRef = (0, $bJbxN$useDOMRef)(ref);
    return /*#__PURE__*/ (0, $bJbxN$react).createElement("footer", {
        ...(0, $bJbxN$filterDOMProps)(otherProps),
        ...styleProps,
        ref: domRef
    }, /*#__PURE__*/ (0, $bJbxN$react).createElement((0, $bJbxN$ClearSlots), null, children));
}
/**
 * Footer represents a footer within a Spectrum container.
 */ const $8d68cc89c1f9278e$export$a06f1c675e846f6f = /*#__PURE__*/ (0, $bJbxN$forwardRef)($8d68cc89c1f9278e$var$Footer);


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 


function $aedcc4886d2a392a$var$Header(props, ref) {
    props = (0, $bJbxN$useSlotProps)(props, "header");
    let { children: children, ...otherProps } = props;
    let { styleProps: styleProps } = (0, $bJbxN$useStyleProps)(otherProps);
    let domRef = (0, $bJbxN$useDOMRef)(ref);
    return /*#__PURE__*/ (0, $bJbxN$react).createElement("header", {
        ...(0, $bJbxN$filterDOMProps)(otherProps),
        ...styleProps,
        ref: domRef
    }, /*#__PURE__*/ (0, $bJbxN$react).createElement((0, $bJbxN$ClearSlots), null, children));
}
/**
 * Header represents a header within a Spectrum container.
 */ const $aedcc4886d2a392a$export$8b251419efc915eb = /*#__PURE__*/ (0, $bJbxN$forwardRef)($aedcc4886d2a392a$var$Header);




export {$b9606c0c41d55371$export$27a5bd065ad55220 as View, $0a7c18a2ef74b280$export$7c6e2c02157bb7d2 as Content, $8d68cc89c1f9278e$export$a06f1c675e846f6f as Footer, $aedcc4886d2a392a$export$8b251419efc915eb as Header};
//# sourceMappingURL=module.js.map
